import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { site } from "../data/site";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "Service Areas", to: "/locations" },
  { label: "About", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const overHero = location.pathname === "/" && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition ${
        scrolled || mobileOpen ? "border-b border-background-200 bg-background-50/95 shadow-sm backdrop-blur" : "bg-transparent"
      }`}
    >
      <div className="section-shell flex h-20 items-center justify-between">
        <Link to="/" className={`flex items-center gap-3 ${overHero ? "text-white" : "text-foreground-950"}`}>
          <img src={site.logo} alt="Polishing Singapore" className="h-10 w-auto rounded-sm bg-white/90 p-1" />
          <span className="hidden font-heading text-xl font-bold sm:inline">{site.brand}</span>
        </Link>

        <nav className={`hidden items-center gap-1 lg:flex ${overHero ? "text-white" : "text-foreground-800"}`}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-semibold transition hover:text-primary-500 ${
                  isActive ? "text-primary-500" : ""
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/contact" className="ml-3 btn-primary">
            Request Quote
          </Link>
        </nav>

        <button
          type="button"
          className={`flex h-11 w-11 items-center justify-center rounded-md border transition lg:hidden ${
            overHero ? "border-white/30 text-white" : "border-background-300 text-foreground-950"
          }`}
          aria-label="Toggle navigation"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((open) => !open)}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="section-shell grid gap-1 py-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-sm font-semibold ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/contact" className="mx-4 my-2 btn-primary">
              Request Quote
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
